import api from "../lib/api";

export interface SecuritySettings {
  rateLimitEnabled: boolean;
  otpCooldownEnabled: boolean;
  updatedAt: string | null;
}

export const saveSecuritySettings = (
  payload: Partial<Pick<SecuritySettings, "rateLimitEnabled" | "otpCooldownEnabled">>,
) => api.post("/api/admin/security-settings/save", payload);
